// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import { Box, Paper, styled } from "@3778.care/goban";
import { subHours } from "date-fns";
import PropTypes from "prop-types";

import {
  getAppointmentLocation,
  getAppointmentStatus,
} from "../../domain/appointment";
import {
  AppointmentActions,
  AppointmentHeader,
  AppointmentLocation,
} from "./components";

const StyledPaper = styled(Paper)(({ theme: { breakpoints, spacing } }) => ({
  height: "100%",
  padding: spacing(1.5),
  [breakpoints.up("md")]: {
    padding: spacing(2.5, 3),
  },
}));

const getAppointmentType = (appointment, location) => {
  if (appointment.patientInstruction) {
    return "video";
  }

  return location ? "faceToFace" : "phone";
};

const getAppointmentSubtitle = (appointmentType) =>
  ({
    faceToFace: "Consulta presencial",
    phone: "Consulta por telefone",
    video: "Consulta por videochamada",
  }[appointmentType]);

export const AppointmentCard = ({ appointment }) => {
  const appointmentLocation = getAppointmentLocation(appointment);
  const appointmentType = getAppointmentType(appointment, appointmentLocation);
  const appointmentStatus = getAppointmentStatus(appointment);
  const appointmentSubtitle = getAppointmentSubtitle(appointmentType);

  const showActions =
    ["inProgress", "booked"].includes(appointmentStatus) &&
    subHours(new Date(), 1).toISOString() < appointment.end;

  return (
    <StyledPaper data-cy="appointment-card" sx={{ boxShadow: 3 }}>
      <AppointmentHeader
        appointment={appointment}
        appointmentStatus={appointmentStatus}
        appointmentSubtitle={appointmentSubtitle}
      />

      {appointmentType === "faceToFace" && (
        <AppointmentLocation location={appointmentLocation} />
      )}

      {showActions && (
        <Box paddingTop={2}>
          <AppointmentActions
            appointment={appointment}
            appointmentType={appointmentType}
            appointmentLocation={appointmentLocation}
          />
        </Box>
      )}
    </StyledPaper>
  );
};

AppointmentCard.propTypes = {
  appointment: PropTypes.object.isRequired,
};
